import React from 'react';

import { Link } from 'gatsby';
import ProductMainMenu from '../../components/ProductMainMenu';

import '../../styles/layout/components/navbar.scss';

import useLanguage from '../../hooks/useLanguage';

import enMessages from '../../i18n/navbar/en';
import ruMessages from '../../i18n/navbar/ru';

const messages = {
  en: enMessages,
  ru: ruMessages,
};

const Navbar = ({ locale }) => {
  const [currentLanguage] = useLanguage();

  return (
    <nav className="Menu">
      <ul className="Menu-List">
        {locale === 'ru' && (
          <li className="Menu-ListCell Menu-ListCell_hasSubmenu Menu-ListCell_hasRelativeSubmenu">
            <span className="Menu-Link">{messages[locale].forIndividuals}</span>
            <div className="Submenu">
              <div className="Submenu-Inner">
                <div className="menuLinksList">
                  <Link
                    className="menuLink"
                    to={`${currentLanguage === 'en' ? '/en' : ''}/deposits`}
                    activeClassName="active"
                  >
                    {messages[locale].deposits}
                  </Link>
                  <Link
                    className="menuLink"
                    to={`${currentLanguage === 'en' ? '/en' : ''}/debit-cards`}
                    activeClassName="active"
                  >
                    {messages[locale].debitCards}
                  </Link>
                </div>
              </div>
            </div>
          </li>
        )}

        <li className="Menu-ListCell Menu-ListCell_hasSubmenu">
          <span className="Menu-Link">
            {messages[locale].businessSolutions}
          </span>
          <div className="Submenu Submenu_withIcons">
            <div className="Submenu-Inner">
              <div className="clearNegativeMargin">
                <ProductMainMenu menu={messages[locale].mainMenuItems} />
              </div>
            </div>
          </div>
        </li>

        {locale === 'ru' && (
          <li className="Menu-ListCell">
            <Link
              to={`${currentLanguage === 'en' ? '/en' : ''}/contacts`}
              className="Menu-Link"
              activeClassName="active"
              partiallyActive={true}
            >
              {messages[locale].feedback}
            </Link>
          </li>
        )}

        <li className="Menu-ListCell Menu-ListCell_hasSubmenu Menu-ListCell_hasRelativeSubmenu">
          <span className="Menu-Link">{messages[locale].company}</span>
          <div className="Submenu">
            <div className="Submenu-Inner">
              <div className="menuLinksList">
                <Link
                  className="menuLink"
                  to={`${currentLanguage === 'en' ? '/en' : ''}/legal/offices`}
                  activeClassName="active"
                >
                  {messages[locale].offices}
                </Link>
                <Link
                  className="menuLink"
                  to={`${currentLanguage === 'en' ? '/en' : ''}/about`}
                  activeClassName="active"
                >
                  {messages[locale].aboutBank}
                </Link>
                <Link
                  className="menuLink"
                  to={`${currentLanguage === 'en' ? '/en' : ''}/careers`}
                  activeClassName="active"
                >
                  {messages[locale].vacancy}
                </Link>
                <Link
                  className="menuLink"
                  to={`${currentLanguage === 'en' ? '/en' : ''}/blog`}
                  activeClassName="active"
                >
                  {messages[locale].blog}
                </Link>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
